import { createBrowserRouter, Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store';
import { ChatPage } from '@/pages/Chat';
import { LoginPage } from '@/pages/Login';
import { StatsPage } from '@/pages/Stats';
import { Admin } from '@/pages/Admin';
import { ContentPage } from '@/pages/Content';

// 保留查询参数的重定向辅助函数
function buildRedirectPath(path: string, search: string): string {
  return search ? `${path}${search}` : path;
}

// 受保护的路由（未登录重定向到 /login，保留查询参数）
function ProtectedRoute() {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();
  if (isAuthenticated) {
    return <Outlet />;
  }
  return <Navigate to={buildRedirectPath('/login', location.search)} replace />;
}

// 公开路由（已登录用户跳转首页，保留查询参数）
function PublicRoute() {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();
  if (!isAuthenticated) {
    return <Outlet />;
  }
  return <Navigate to={buildRedirectPath('/', location.search)} replace />;
}

// 404 fallback（保留查询参数）
function NotFoundRedirect() {
  const location = useLocation();
  return <Navigate to={buildRedirectPath('/', location.search)} replace />;
}

export const router = createBrowserRouter([
  {
    element: <PublicRoute />,
    children: [
      {
        path: '/login',
        element: <LoginPage />,
      },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: '/',
        element: <ChatPage />,
      },
      {
        path: '/stats',
        element: <StatsPage />,
      },
      {
        path: '/admin',
        element: <Admin />,
      },
      {
        path: '/content',
        element: <ContentPage />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFoundRedirect />,
  },
]);
